export enum Roles {
    Admin = "ADM",
    Tutor = "TUT",
    User = "USE",
    None = "NON"
}

export type PermissionSchema = {
    Role: Roles,
};

const nameofPermissionSchemaRole = "Role";
const nameofPermissionSchemaCollection = "Permission";

export {
    nameofPermissionSchemaRole,
    nameofPermissionSchemaCollection,
};

export type PermissionView = PermissionSchema & {
    Id: string,
};